// Detects the visitor's operating system from navigator hints.
// Falls back to 'macos' to keep the existing visual default.

export type OS = 'macos' | 'windows' | 'linux'

export const detectOS = (): OS => {
  if (typeof navigator === 'undefined') return 'macos'

  const navWithUA = navigator as Navigator & {userAgentData?: {platform?: string}}
  const platformHint = navWithUA.userAgentData?.platform ?? ''
  const ua = `${platformHint} ${navigator.userAgent}`.toLowerCase()

  if (ua.includes('mac') || ua.includes('iphone') || ua.includes('ipad')) return 'macos'
  if (ua.includes('win')) return 'windows'
  if (ua.includes('linux') || ua.includes('x11') || ua.includes('android')) return 'linux'
  return 'macos'
}
